<fieldset class="border rounded-3 p-1">
    <legend class="float-none w-auto px-1 font-size-13 bold">{{ 'ESTIMATE_TOTALS' | translate}}</legend>
    <div class="estimate-tools-row">
        <div class="bold" class="left-align">{{ 'COST' | translate}}:</div>
        <div class="bold" class="right-align">{{ subTotals?.controls.cost.value | multilingualCurrency }}</div>
    </div>
    <div class="estimate-tools-row">
        <div class="bold" class="left-align">{{ 'ESCALATION' | translate}}:</div>
        <div class="bold" class="right-align">
            {{ escalationTotal | multilingualCurrency }}
        </div>
    </div>
    <div class="estimate-tools-row">
        <div class="bold" class="left-align">
            @if (isMarkUpSelected) { {{ 'MU_PERCENT' | translate}}: } @else { {{ 'GM_PERCENT' | translate}}: }
        </div>
        <div class="bold" class="right-align">
            @if (isMarkUpSelected) {
                {{ sellAsCalculated?.controls.markUpPercentage.value | decimalPrecision }}%
            } @else {
                {{ sellAsCalculated?.controls.grossMarginPercentage.value | decimalPrecision }}%
            }
        </div>
    </div>
    <div class="estimate-tools-row">
        <div class="bold" class="left-align">{{ 'SELL' | translate}}:</div>
        <div class="bold" class="right-align">{{ estimateFormGroup?.controls.sellAs.controls.sellAsSellPrice.value | multilingualCurrency }}</div>
    </div>
    <div class="estimate-tools-row">
        <div class="left-align"></div>
        <div class="right-align"></div>
    </div>
    <div class="estimate-tools-row">
        <div class="left-align"></div>
        <div class="right-align"></div>
    </div>
</fieldset>